module.exports = __webpack_public_path__ + "img/banner1.c40e1cb6.jpg";